import { useEffect, useState } from 'react'
import { useChannel } from '@/context/ChannelContext'
import { getOnboardingState } from '@/api/onboarding'

/**
 * Returns the channelUUID pinned to the current onboarding session.
 * Reads from /onboarding/state first; falls back to selectedChannel only if no session.
 *
 * This avoids picking the wrong channel when user switches selectedChannel
 * via ProjectSelector during an active onboarding flow.
 */
export function usePinnedChannelUUID(): string | null {
  const { selectedChannel } = useChannel()
  const [channelUUID, setChannelUUID] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false
    getOnboardingState()
      .then((s) => {
        if (cancelled) return
        if (s.channelUUID) {
          setChannelUUID(s.channelUUID)
        } else if (selectedChannel?.uuid) {
          setChannelUUID(selectedChannel.uuid)
        }
      })
      .catch(() => {
        if (!cancelled && selectedChannel?.uuid) setChannelUUID(selectedChannel.uuid)
      })
    return () => {
      cancelled = true
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return channelUUID
}
